// extracted by mini-css-extract-plugin
export var analytics = "_mg-e";
export var checkoutNode = "_mg-p";
export var clampedValueText = "_mg-c";
export var dropCircle = "_mg-i";
export var dropCircleIcon = "_mg-m";
export var dropHitbox = "_mg-h";
export var dropNode = "_mg-l";
export var dropNodeOver = "_mg-o";
export var dropNodeValid = "_mg-n";
export var dropZoneWrapper = "_mg-g";
export var expandedDropRadius = "_mg-j";
export var expandedValid = "_mg-k";
export var fullInput = "_mg-9";
export var fullWidth = "_mg-a";
export var halfInput = "_mg-8";
export var invalid = "_mg-6";
export var metricsCalloutContainer = "_mg-q";
export var node = "_mg-4";
export var nodeWrapper = "_mg-0";
export var nodeWrapperHovered = "_mg-2";
export var nodeWrapperInvalid = "_mg-3";
export var nodeWrapperInvalidSelected = "_mg-5";
export var nodeWrapperSelected = "_mg-1";
export var placeholderText = "_mg-d";
export var secondaryMetric = "_mg-f";
export var unselectable = "_mg-7";
export var valueText = "_mg-b";